module.exports = __webpack_public_path__ + "img/STORM.d3381ffe.svg";